<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="SQL Workbench" active/>
		</b-breadcrumb>
		<b-container fluid>
			<b-button-toolbar key-nav aria-label="Toolbar with button groups" class="pb-2">
				<b-button-group class="mx-1">
					<b-button variant="outline-primary" @click="onExecuteQuery()" :disabled="query === ''" v-b-tooltip.hover title="Execute query"><icon name="play"></icon></b-button>
					<b-button variant="outline-primary" @click="onCountQuery()" :disabled="query === ''" v-b-tooltip.hover title="Execute count query"><icon name="calculator"></icon></b-button>
					<b-button variant="outline-primary" @click="prettify()" :disabled="query === ''" v-b-tooltip.hover title="Prettify SQL"><icon name="align-left"></icon></b-button>
					<b-button variant="outline-primary" @click="onClear()" v-b-tooltip.hover title="Clear editor"><icon name="eraser"></icon></b-button>
					<b-button variant="outline-primary" @click="tabs = []" v-b-tooltip.hover title="Close all tabs"><icon name="times"></icon></b-button>
				</b-button-group>
				<b-button-group class="mx-1">
					<b-button variant="outline-primary" @click="syncCatalog()" v-b-tooltip.hover title="Sync catalog"><icon name="sync"></icon></b-button>
					<b-button variant="outline-primary" @click="onToggleCatalogTree()" v-b-tooltip.hover title="Show catalog"><icon name="database"></icon></b-button>
					<b-button variant="outline-primary" @click="onToggleSavedQueries()" v-b-tooltip.hover title="Show saved queries"><icon name="file-alt"></icon></b-button>
					<b-button variant="outline-primary" @click="onToggleEditor()" v-b-tooltip.hover title="Switch editors"><icon name="edit"></icon></b-button>
				</b-button-group>
			</b-button-toolbar>
			<splitpanes class="splitpanes" style="height: 750px" @resize="preferences.catalogPaneSize = $event[0].size">
				<pane v-if="preferences.showCatalogTree" :size="preferences.catalogPaneSize" style="display:block; overflow: auto" class="p-2">
					<a-catalog-viewer @tableClicked="showTable"/>
				</pane>
				<pane size="70">
					<b-container fluid class="m-0 p-0">
					<b-row>
						<b-col>
							<splitpanes vertical class="splitpanes" style="height: 260px">
								<pane size="70">
									<b-form-textarea v-if="preferences.editor === 'classic'" id="query" ref="query" @change="onQueryChange" type="text" v-model="query" class="text-monospace" rows="10" no-resize></b-form-textarea>
									<a-code-editor v-if="preferences.editor === 'new'" v-model="query" lineNumbers @change="onQueryChange"></a-code-editor>
								</pane>
								<pane size="30" min-size="10" class="m-0 p-0" v-if="preferences.showSavedQueries">
									<a-saved-queries username="user" @copyQuery="onCopyQuery" @executeQuery="onExecuteSavedQuery"/>
								</pane>
							</splitpanes>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-card no-body v-if="tabs.length > 0">
								<el-tabs type="card" v-model="activeTab" class="mt-2">
									<el-tab-pane v-for="tab in tabs" v-bind:key="tab.id" class="p-1">
										<template #label>
											<b-spinner type="border" small v-if="tab.status !== 'Done'"></b-spinner>
											<span v-if="tab.status === 'Done'">
												<icon v-if="tab.type === 'table'" name="table"></icon>
											</span>
											<strong>{{tab.name}}</strong>&nbsp;
											<span @click="deleteTab(tab.id)">
												<icon name="times"></icon>
											</span>
										</template>
										<b-card-text>
											<a-query v-if="tab.type === 'query'" :query="tab" @onComplete="onComplete" />
											<a-table-info v-if="tab.type === 'table'" :tab="tab" @onComplete="onComplete"/>
										</b-card-text>
									</el-tab-pane >
								</el-tabs>
							</b-card>
							<!--
							<b-card no-body v-if="tabs.length > 0">
								<b-tabs card v-model="activeTab">
									<b-tab v-for="tab in tabs" v-bind:key="tab.id" class="p-1">
										<template #title>
											<b-spinner type="border" small v-if="tab.status !== 'Done'"></b-spinner>
											<strong>{{tab.id}}</strong>&nbsp;
											<span @click="deleteTab(tab.id)">
												<icon name="times"></icon>
											</span>
										</template>
										<b-card-text>
											<a-query v-if="tab.type === 'query'" :query="tab" @onComplete="onComplete" >
											</a-query>
										</b-card-text>
									</b-tab>
								</b-tabs>
							</b-card>
							-->
						</b-col>
					</b-row>
					</b-container>
				</pane>
			</splitpanes>
		</b-container>
	</div>
</template>
<script>
import {HTTP} from '../services/HttpService'

export default {
  name: 'sql-workbench',
  data: () => ({
    preferences: {
      showCatalogTree: true,
      catalogPaneSize: 30,
      showSavedQueries: true,
      editor: 'new'
    },
    index: 1,
    query: '',
    tabs: [],
    activeTab: 0
  }),
  methods: {
    viewSize () {
      if (this.preference.showCatalogTree === false) {
        return 100
      } else {
        return 100 - this.preference.catalogPaneSize
      }
    },
    onToggleCatalogTree () {
      this.preferences.showCatalogTree = !this.preferences.showCatalogTree
      localStorage.setItem('sql.workbench.preferences', JSON.stringify(this.preferences))
    },
    onToggleSavedQueries () {
      this.preferences.showSavedQueries = !this.preferences.showSavedQueries
      localStorage.setItem('sql.workbench.preferences', JSON.stringify(this.preferences))
    },
    onToggleEditor () {
      if (this.preferences.editor === 'classic') {
        this.preferences.editor = 'new'
      } else {
        this.preferences.editor = 'classic'
      }
      localStorage.setItem('sql.workbench.preferences', JSON.stringify(this.preferences))
    },
    onQueryChange (query) {
      console.log('onQueryChange=' + query)
      localStorage.setItem('sql.workbench.query', this.query)
    },
    getSelectedText () {
      var start = this.$refs['query'].selectionStart
      var end = this.$refs['query'].selectionEnd
      if (start === end) {
        return ''
      }
      return this.query.substring(start, end)
    },
    onClear () {
      this.query = ''
      localStorage.setItem('sql.workbench.query', this.query)
    },
    onExecuteQuery () {
      if (this.preferences.editor === 'new') {
        this.executeQuery(this.query)
        return
      }
      var queryToExecute = this.getSelectedText()
      if (queryToExecute === '') {
        queryToExecute = this.query
      }
      this.executeQuery(queryToExecute)
    },
    onCountQuery () {
      if (this.preferences.editor === 'new') {
        let queryToExecute = 'SELECT COUNT(*) AS TOTAL FROM (' + this.query + ')'
        this.executeQuery(queryToExecute)
        return
      }
      var queryToExecute = this.getSelectedText()
      if (queryToExecute === '') {
        queryToExecute = this.query
      }
      queryToExecute = 'SELECT COUNT(*) AS TOTAL FROM (' + queryToExecute + ')'
      this.executeQuery(queryToExecute)
    },
    executeQuery (query) {
      var tab = {
        id: this.index++,
        name: this.index,
        type: 'query',
        sql: query,
        status: 'Pending'
      }
      this.tabs.push(tab)
    },
    prettify () {
      const formData = new FormData()
      formData.append('query', this.query)
      HTTP.post('api/query/prettify', formData)
        .then(response => {
          console.log('Processing response')
          this.query = response.data
        })
    },
    onComplete (id) {
      console.log('onComplete->' + id)
      for (var tab in this.tabs) {
        if (this.tabs[tab].id === id) {
          this.activeTab = tab
          break
        }
      }
    },
    deleteTab (id) {
      for (var tab in this.tabs) {
        if (this.tabs[tab].id === id) {
          this.tabs.splice(tab, 1)
          break
        }
      }
    },
    onExecuteSavedQuery (query) {
      console.log(query)
      // this.executeQuery(query.query)
      var tab = {
        id: this.index++,
        name: query.name,
        type: 'query',
        sql: query.query,
        status: 'Pending'
      }
      this.tabs.push(tab)
    },
    onCopyQuery (query) {
      console.log(query)
      if (this.query.trim() === '') {
        this.query = query.query
      } else {
        this.query = this.query + ';\n' + query.query
      }
    },
    showTable (table) {
      var tab = {
        id: this.index++,
        name: table.name,
        type: 'table',
        tableId: table.id,
        status: 'Pending'
      }
      this.tabs.push(tab)
    }
  },
  created () {
    // localStorage.setItem('sql.workbench.preferences', null)
    this.query = localStorage.getItem('sql.workbench.query')
    let preferences = localStorage.getItem('sql.workbench.preferences')
    if (preferences === null || preferences === 'null') {
      console.log('Setting default preferences')
      this.preferences = {
        showCatalogTree: true,
        catalogPaneSize: 30,
        showSavedQueries: true,
        editor: 'new'
      }
    } else {
      this.preferences = JSON.parse(preferences)
    }
  }
}
</script>

<style scoped>
textarea, textarea:focus {
	border: none;
	outline: none;
	background-color: transparent;
	box-shadow: none;
	border-style: none;
	border-color: Transparent;
}
.splitpanes {
}

.splitpanes__pane {
	box-shadow: 0 0 1px rgba(0, 0, 0, 1) inset;
	display: flex;
	}

.splitpanes--vertical > .splitpanes__splitter {
	min-width: 2px;
	background: #777;
}

.splitpanes--horizontal > .splitpanes__splitter {
	min-height: 1px;
	background: #777;
}
</style>



// WEBPACK FOOTER //
// SQLWorkbenchPage.vue?f630e8ec